import type {
  SubPortfolioCorrection,
  SubPortfolioLifeRef,
} from '@festina/unitlink-general-types/unitlink'
import { typeUtils, type ValidatedKey } from '@festina-life/core'
import {
  FormikDoubleInput,
  FormikFieldArray,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'
import { useField } from 'formik'

import { FundCorrectionFields } from './FundCorrectionFields'
import { SubPortfolioLifeRefFields } from './SubPortfolioLifeRefFields'

type Props = {
  fieldNamePrefix: ValidatedKey
}

export const SubPortfolioCorrectionFields = ({ fieldNamePrefix }: Props) => {
  const translate = useTranslate()

  const validateKey =
    typeUtils.createNestedValidator<SubPortfolioCorrection>(fieldNamePrefix)

  const [
    {
      value: { coverKey },
    },
  ] = useField<SubPortfolioLifeRef>(validateKey('subPortfolioRef'))

  return (
    <>
      <SubPortfolioLifeRefFields
        fieldNamePrefix={validateKey('subPortfolioRef')}
      />
      <FormikDoubleInput
        name={validateKey('amount')}
        label={translate('subPortfolioCorrection.amount')}
      />
      <FormikFieldArray
        name={validateKey('fundCorrections')}
        label={translate('subPortfolioCorrection.fundCorrections')}
        elementLabel={translate('subPortfolioCorrection.fundCorrection')}
        elementInitializer={() => ({ _type: 'FundCorrection' })}
        ChildElement={FundCorrectionFields}
        childProps={{ coverKey }}
      />
    </>
  )
}
